import { HttpHeaders } from "@angular/common/http";

export interface IHttpRepo{
    Get(relativeUrl:string),
    Put(relativeUrl:string,data:any),
    Post(relativeUrl:string,data:any),
    Delete(relativeUrl:string,data:any)
}

export class HttpContentType {
    static JSON:HttpHeaders=new HttpHeaders({
        'Content-Type': 'application/json'  
    })    
    
    static URLENCODED:HttpHeaders=new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'  
    })
}

export class EncType{
    static multiPartFormData=new HttpHeaders({
        "enctype": "multipart/form-data"
    })
}